var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLink2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.71574 5.54244L1.34398 6.9142C0.172404 8.08577 0.172404 9.98527 1.34398 11.1568C2.51555 12.3284 4.41504 12.3284 5.58662 11.1568L7.41504 9.32842C8.58662 8.15684 8.58662 6.25735 7.41504 5.08577C7.16711 4.83784 6.88657 4.64237 6.58723 4.49938L6.00083 5.08578C5.93985 5.14675 5.88839 5.21365 5.84646 5.28461C6.1619 5.37499 6.45947 5.54442 6.70794 5.79288C7.48899 6.57393 7.48899 7.84026 6.70794 8.62131L4.87951 10.4497C4.09846 11.2308 2.83213 11.2308 2.05108 10.4497C1.27003 9.66869 1.27003 8.40236 2.05108 7.62131L2.84369 6.8287C2.73149 6.40858 2.68884 5.97375 2.71574 5.54244Z",
    fill: "#369FE7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58662 3.67156C3.41504 4.84313 3.41504 6.74263 4.58662 7.9142C4.83455 8.16214 5.11509 8.3576 5.41443 8.5006L6.19003 7.72501C5.86169 7.63732 5.55131 7.46468 5.29372 7.2071C4.51268 6.42605 4.51267 5.15972 5.29372 4.37867L7.12215 2.55024C7.9032 1.76919 9.16953 1.76919 9.95058 2.55024C10.7316 3.33129 10.7316 4.59762 9.95058 5.37867L9.15797 6.17128C9.27017 6.5914 9.31282 7.02623 9.28592 7.45754L10.6577 6.08577C11.8293 4.9142 11.8293 3.01471 10.6577 1.84313C9.48611 0.671561 7.58662 0.671561 6.41504 1.84313L4.58662 3.67156Z",
    fill: "#369FE7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink2);
export default __webpack_public_path__ + "static/media/Link2.2300db57c87412812290e6bbf0ca6d1d.svg";
export { ForwardRef as ReactComponent };